import { Button, DialogActions } from '@tunasong/ui-lib'
import { dayjs, shortUuid } from '@tunasong/models'
import { getDefaultYDocString } from '@tunasong/plugin-lib'
import type { CalendarEvent, Profile } from '@tunasong/schemas'
import { isCalendarEvent } from '@tunasong/schemas'
import type { CDialogProps } from '@tunasong/ui-lib'
import { Dialog } from '@tunasong/ui-lib'
import { useState } from 'react'
import { toAttendee } from '../lib/to-attendee.js'
import CalendarEventEdit from './event-edit.js'

/** We can create the calendar from the JSON created by calendar.toJSON() */
interface CalendarEventDialogProps extends CDialogProps {
  defaultEvent?: CalendarEvent
  defaultAttendees?: Profile[]
  organizer: Profile
  edit?: boolean
  onSave: (event: CalendarEvent) => void
}

export const CalendarEventDialog = (props: CalendarEventDialogProps) => {
  const { defaultEvent, defaultAttendees, organizer, open, onSave, ...restProps } = props

  // Get the first whole hour from now
  const defaultStart = dayjs().add(1, 'hour').startOf('hour')
  const defaultEnd = defaultStart.add(1, 'hour')

  /** Dialog */
  const [event, setEvent] = useState<CalendarEvent>(
    defaultEvent ?? {
      // Set the ID client side, so we can update the UI immediately
      id: shortUuid(),
      type: 'calendarevent',
      name: '',
      description: '',
      start: defaultStart.toISOString(),
      end: defaultEnd.toISOString(),
      organizer: toAttendee(organizer),
      attendees: defaultAttendees?.map(toAttendee) ?? [],
      yDoc: getDefaultYDocString('calendar-temporary-id'),
    }
  )
  const handleChange = (partialEvent: Partial<CalendarEvent>) => setEvent(event => ({ ...event, ...partialEvent }))

  const isValid = isCalendarEvent(event) && event.name

  return (
    <Dialog open={open} maxWidth="xs" fullWidth {...restProps}>
      <CalendarEventEdit onPartialChange={handleChange} event={event} />
      <DialogActions>
        <Button color="primary" disabled={!isValid} onClick={() => isValid && onSave(event)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}
